import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {CarAddContent} from "../components/contentComponents/CarAddContent";
import {useParams} from "react-router-dom";

export function CarAdd() {
    return (
        <div>
            <Header active={"settings-active"}></Header>
            <CarAddContent></CarAddContent>
            <Footer></Footer>
        </div>
    )
}
